import type { FaireProductEntity } from "../../entity_types/product";

export const p_x9sq93qvb8: FaireProductEntity = {
  token: "p_x9sq93qvb8",
  type: "product",
  name: "Fomin | Eco-Friendly Toilet Bowl Cleaner Strips | 15 Strips",
  brandToken: "b_qpbga97kpu",
  brandName: "Unknown Brand",
  imageUrl: "https://cdn.faire.com/fastly/4b7c36877c499bf417515a094769ce5b85ab2526b308ff6efca5cd3deb514918.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d35dbe314d502d1aa5d89945eca256b792cd2101360ba05dea717d0fe083a62a.jpeg",
    "https://cdn.faire.com/fastly/48809ce7f14b95bb05e6a920545b3c9042636ad9d69fc170cde7c158d5eb72df.jpeg",
    "https://cdn.faire.com/fastly/722eb624cf463272c9115d4e35b6d8bd69314679c3543b6db2d900c88813c85b.jpeg"
  ],
  priceDollars: 14,
  description: "- TOUGH ON STAINS: Fomin toilet bowl cleaner strips will dissolve in seconds and can effectively remove urine stains, lime scales, and other stubborn stains with the help of the brush. They are septic safe, offering a conscientious choice for your household and the environment.\n\n- HOW IT WORKS: Simply place 1 toilet bowl cleaner strip into the bowl. Allow them to dissolve for approximately 30 seconds, then scrub and flush. (Hint: Prior to scrubbing, moisten the sheet with the shower to generate ample foam.\n\n- SAVE YOUR WALLET & THE PLANET: Fomin toilet bowl cleaner strips are Plastic Bank meaning each purchase removes 12 bottles from the ocean. They are 100% vegan and carbon neutral. Our products are cruelty free and never tested on animals.\n\n- HIGHLY EFFECTIVE & SAFE: Fomin flushable toilet cleaner strips outperformed in both cleaning and scent. Our clean toilet bowl cleaner strips are free of chemicals making them safe for infants, kids, your pets, and our environment.",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:51.384Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
